import React from 'react';
import { Typography, Space, Divider } from 'antd';

const { Title, Text } = Typography;

/**
 * Props do componente PageHeader.
 */
interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: React.ReactNode;
}

/**
 * Header de página padronizado com título, subtítulo e ações.
 * 
 * Componente customizado para substituir o PageHeader removido do Ant Design 5.x.
 * 
 * @param title - Título da página
 * @param subtitle - Subtítulo da página (opcional)
 * @param actions - Ações adicionais (opcional)
 */
export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  actions,
}) => {
  return (
    <div style={{ marginBottom: 24 }}>
      <Space direction="vertical" size="small" style={{ width: '100%' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          <div>
            <Title level={2} style={{ margin: 0 }}>
              {title}
            </Title>
            {subtitle && (
              <Text type="secondary" style={{ fontSize: 14 }}>
                {subtitle}
              </Text>
            )}
          </div>
          {actions && (
            <Space>{actions}</Space>
          )}
        </div>
      </Space>
      <Divider style={{ margin: '16px 0' }} />
    </div>
  );
};

export default PageHeader;

